module.exports = __webpack_public_path__ + "img/share-default.52143292.png";